import React from "react";
import "../../assets/scss/purpleTheme/components/card.scss";

const Card = (props) => {
  const { className, children, height, zIndex, minHeight, bg, width } = props;
  const combinedClassName = `card-transparent ${className || ''}`;

  return (
    <div className={combinedClassName} style={{height: height, zIndex:zIndex, minHeight: minHeight, backgroundColor:bg, width: width}}>
      {children}
    </div>
  );
};

export default Card;
